<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            :name="'nome'"
            v-model="formulario.nome"
            :placeholder="'Nome do Tipo de Serviço'"
            data-vv-as="Nome do Tipo de Serviço"
            v-validate="'required|max:100'"
            :error="validationErrors.first('nome')"
          />
        </div>
      </div>
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            name="descricao"
            type="textarea"
            rows="2"
            placeholder="Descrição"
            data-vv-as="Descrição"
            v-model="formulario.descricao"
            :error="validationErrors.first('descricao')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button
              class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
              type="submit"
            >
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button
              class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
              type="button"
              @click="fecharModal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioCtrlTipoServicoComponent',

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    ctrlTipoServico: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      formulario: {
        id: this.ctrlTipoServico.id || null,
        nome: this.ctrlTipoServico.nome || '',
        descricao: this.ctrlTipoServico.descricao || '',
      }
    }
  },

  methods: {
    ...mapActions('ctrlTipoServico', ['salvarTipoServico', 'atualizarTipoServico']),

    async submit () {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      if (this.tipoFormulario === 'salvar') {
        await this.salvarTipoServico(this.formulario)
      } else {
        await this.atualizarTipoServico(this.formulario)
      }

      this.$emit('atualizarListagemTabela')
      this.limparCampos()
      this.fecharModal()
    },

    limparCampos () {
      this.formulario = {
        nome: '',
      }
      this.$validator.reset()
    },

    fecharModal () {
      this.$emit('fechar')
    }
  }
}
</script>
